(function () {
  let overlay = null;
  let listenersBound = false;

  const syncOverlay = () => {
    const drawerOverlay = document.querySelector('#CartDrawer .paypo__overlay');
    const bodyOverlay = document.body.querySelector(':scope > .paypo__overlay');

    if (drawerOverlay && bodyOverlay && drawerOverlay !== bodyOverlay) {
      bodyOverlay.remove();
    }

    overlay = drawerOverlay || document.querySelector('.paypo__overlay');

    if (!overlay) {
      bodyOverlay?.remove();
      document.body.style.overflow = '';
      return;
    }

    if (overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }
  };

  const openPopup = () => {
    syncOverlay();
    if (!overlay) return;

    const iframe = overlay.querySelector('.paypo__container');
    const iframeSrc = iframe?.dataset.src;

    if (iframe && iframeSrc && !iframe.src) {
      iframe.src = iframeSrc;
    }

    document.body.style.overflow = 'hidden';
    overlay.classList.add('paypo--open');
    overlay.setAttribute('aria-hidden', 'false');
  };

  const closePopup = () => {
    if (!overlay) return;

    document.body.style.overflow = '';
    overlay.classList.remove('paypo--open');
    overlay.setAttribute('aria-hidden', 'true');
  };

  const bindGlobalListeners = () => {
    if (listenersBound) return;
    listenersBound = true;

    document.addEventListener('click', (event) => {
      if (event.target.closest('.paypo__open')) {
        event.preventDefault();
        openPopup();
        return;
      }

      if (event.target.closest('.paypo__close')) {
        event.preventDefault();
        event.stopPropagation();
        closePopup();
        return;
      }

      if (overlay?.classList.contains('paypo--open') && event.target === overlay) {
        closePopup();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && overlay?.classList.contains('paypo--open')) {
        closePopup();
      }
    });
  };

  const initPayPoPopup = () => {
    syncOverlay();
    bindGlobalListeners();
  };

  document.addEventListener('DOMContentLoaded', initPayPoPopup);
  document.addEventListener('shopify:section:load', initPayPoPopup);
  document.addEventListener('cart:change', initPayPoPopup);

  window.initPayPoPopup = initPayPoPopup;
})();
